import axios from 'axios';

function getSearchResults(params) {
  return axios
    .get('/flatshare/api.pl', {
      params,
    })
    .then((data) => data.data);
}

export default getSearchResults;
